import { FC } from 'react';

import cn from 'classnames';

import s from './MyAdvertisementSkeleton.module.scss';
export const MyAdvertisementSkeleton: FC = () => {
  return (
    <div className={s.container}>
      <div className={s.left}></div>
      <div className={s.right}>
        <div className={s.top}>
          <span className={cn(s.text, s.one)}></span>
          <span className={cn(s.text, s.two)}></span>
          <span className={cn(s.text, s.three)}></span>
          <span className={cn(s.text, s.four)}></span>
        </div>
        <div className={s.footer}>
          <span className={cn(s.text, s.one)}></span>
          <span className={cn(s.text, s.two)}></span>
        </div>
      </div>
    </div>
  );
};
